import { io, Socket } from 'socket.io-client';
import type { ClientToServer, ServerToClient } from '../../shared/types.js';

export type AppSocket = Socket<ServerToClient, ClientToServer>;

export function connect(): AppSocket {
  // Connects to the same origin; vite proxies /socket.io in dev.
  return io({ transports: ['websocket', 'polling'], autoConnect: true });
}
